import React from "react";
import { Box, Grid } from "@mui/material";

const PageHeader = ({ breadcrumb, title }) => {
  return (
    <Grid item xs={12}>
      {/* Optional Breadcrumb */}
      {/* {breadcrumb && (
        <Box sx={{ mb: 1 }}>
          <Box
            sx={{
              fontFamily: "Poppins",
              fontSize: "14px",
              color: "#6B7280",
            }}
          >
            {breadcrumb}
          </Box>
        </Box>
      )} */}

      {/* Responsive Title */}
      <Box
        sx={{
          fontFamily: "Poppins",
          fontWeight: 700,
          fontSize: {
            xs: "22px",   // small phones
            sm: "26px",   // tablets
            md: "30px",   // small laptops
            lg: "34px",   // desktops
          },
          lineHeight: {
            xs: "30px",
            sm: "36px",
            md: "40px",
            lg: "42px",
          },
          letterSpacing: "-0.02em",
          width: "100%",
          maxWidth: "987px",
          color: "#02462E",
          padding: {
            xs: "12px",
            sm: "16px",
            md: "20px",
          },
          borderRadius: "8px",
          display: "flex",
          alignItems: "center",
          height: "auto", // no fixed height, so it can wrap nicely
          wordBreak: "break-word",
          flexWrap: "wrap",
        }}
      >
        {title}
      </Box>
    </Grid>
  );
};

export default PageHeader;
